import * as React from 'react';

import theme from '../component/App/theme';
import { ThemeProvider } from '@mui/material/styles';

function PortalThemeProvider({ children }: React.PropsWithChildren<{}>) {
    return (
        <ThemeProvider theme={theme}>
            <>{children}</>
        </ThemeProvider>
    );
}

export default PortalThemeProvider;
